<nav mat-tab-nav-bar class="mat-tab-link-container">
  <a mat-tab-link routerLinkActive="active-link" *ngIf="!isGuest && isAdmin" routerLink="organization" class="overline-o1">{{'profile.sections.organization' | translate}}</a>
  <a mat-tab-link routerLinkActive="active-link" routerLink="user-data" class="overline-o1">{{'profile.sections.user-data' | translate}}</a>
  <a mat-tab-link routerLinkActive="active-link" *ngIf="!isGuest" routerLink="permissions" class="overline-o1">{{'profile.sections.permissions' | translate}}</a>
  <a mat-tab-link routerLinkActive="active-link" *ngIf="!isGuest" routerLink="notifications-configuration" class="overline-o1">{{'profile.sections.configuration' | translate}}</a>
</nav>
<div>
  <router-outlet></router-outlet>
</div>
